module.exports = __webpack_public_path__ + "img/1565619336.4e78952f.jpg";